import { Object3D } from "three";
import { GameResourcesPackage } from "../../../../../resources/GameResourcesPackage";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";

export class TractorTrailParticle extends Object3D {
    private particles: Object3D;
    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly particlesRenderer: BatchedRenderer
    ) {
        super();
        this.particles = clone(this.gameResources.assets_game_particles_tractor_trail_thjson);
        QuarksUtil.setAutoDestroy(this.particles, true);
        QuarksUtil.addToBatchRenderer(this.particles, this.particlesRenderer);
        this.particles.position.set(0, 0.1, 0);
        this.add(this.particles);
    }
}
